import React, { useEffect, useState } from "react";
import Icon from "../Icon/Icon";
import { cn } from "@/shared/utils/cn";

const Whatsapp = ({
  width = "1.75rem",
  phone,
  children,
  isDisabled = false,
}: {
  children?: React.ReactNode;
  width?: string;
  phone: string;
  isDisabled?: boolean;
}) => {
  const [number, setNumber] = useState<string | undefined>(undefined);

  useEffect(() => {
    getNumber().then((number) => setNumber(number));
  }, [phone]);

  const getNumber = async () => {
    const { parsePhoneNumberFromString } = await import("libphonenumber-js");
    const beFormat = parsePhoneNumberFromString(phone, "BE");
    if (beFormat?.isValid() && beFormat.country === "BE") {
      return beFormat.formatInternational().replace(/\s/g, "");
    }
    const dutchFormat = parsePhoneNumberFromString(phone, "NL");
    if (dutchFormat?.isValid() && dutchFormat.country === "NL") {
      return dutchFormat.formatInternational().replace(/\s/g, "");
    }

    const trFormat = parsePhoneNumberFromString(phone, "TR");
    if (trFormat?.isValid() && trFormat.country === "TR") {
      return trFormat.formatInternational().replace(/\s/g, "");
    }
    return undefined;
  };

  return number === undefined ? (
    <></>
  ) : (
    <a target="_blank" rel="noopener" href={`https://wa.me/${number ?? phone}`} className="items-center gap-[1rem] text-[black] flex">
      <Icon
        className={cn(
          width === "1.75rem" ? "h-7 w-7" : `h-[${width}] w-[${width}]`,
          isDisabled ? "fill-disabled" : "fill-[#55D162]"
        )}
        variants="whatsapp"
      />
      <span className="text-[text]">
        {children}
      </span>
    </a>
  );
};

export default Whatsapp;
